import Vue from 'vue';
import VueRouter from 'vue-router';
import { loadLanguageAsync } from '@/i18n';
import routes from './routes';


Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});


// Handling Google Analytics tracking
router.beforeEach((to, from, next) => {
  const { gtag } = window;

  // gtag.js tracking
  if (typeof gtag !== 'undefined') {
    gtag('config', 'UA-146246539-1', {
      page_path: to.path,
    });
  }

  next();
});

// Handling i18n
router.beforeEach((to, from, next) => {
  // Load new language when the language changes
  loadLanguageAsync(to.params.locale).then(() => next());
});

export default router;
